import { BullseyeArrowIcon } from './BullseyeArrowIcon';

/**
 * author: Simran
 * id FAC8D1F3-C466-41F3-B3BF-A08519BBC909
 * name bullseye-arrow
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bullseye-arrow.svg
 * tags
 * - Sport 
 */
export const TargetArrowIcon = BullseyeArrowIcon;
export default TargetArrowIcon